<template>
    <b-row v-if="component">
        <b-form-group>
            <template v-if="this.$can('create ' + this.component.general.name)">
                <b-button variant="success" @click="createModal = true" class="create-button"> Create </b-button>
                <b-modal v-model="createModal" :title="`Create new ${this.field.name}`" size="lg" hide-footer hide-header>
                    <QuickCreate @created="created" :id="this.field.relation.foreign" :settings="{container: {cols:12,md:12}, slotless: true}"/>
                </b-modal>
            </template>

            <template v-if="this.$can('edit ' + this.component.general.name) && this.modelUuid !== null && this.field.relation.type != 'one-to-many'">
                <b-button variant="primary" class="y-2" @click="editModal = true"> Edit </b-button>
                <b-modal v-model="editModal" :title="`Edit ${this.field.name}`" size="lg" hide-footer hide-header>
                    <QuickEdit @edited="edited" @removed="removed" :id="this.field.relation.foreign" :modelUuid="modelUuid" :settings="{container: {cols:12,md:12}, slotless: true}"/>
                </b-modal>
            </template>
        </b-form-group>
    </b-row>
</template>

<style scoped>
.create-button {
    margin-right: 15px;
}
</style>

<script>

export default {
    name: 'SelectRelation',
    components: {
        QuickCreate: () => import("../../base/Create.vue"),
        QuickEdit: () => import("../../base/Edit.vue")
    },
    props: {
        field: {
            type: Object
        },

        value: {
            type: Object
        },
    },
    data: function() {
        return {
            createModal: false,
            editModal: false,
            component: null
        }
    },

    methods: {
        created(data) {
            this.createModal = false;
            let val = {}
            val[this.field.relation.key[0]] = data[this.field.relation.key[1]]
            val[this.field.relation.key[0] + "_RefObj"] = data

            this.$emit("input", val)
        },

        edited(data) {
            this.editModal = false;

            let val = {}
            val[this.field.relation.key[0]] = data[this.field.relation.key[1]]
            val[this.field.relation.key[0] + "_RefObj"] = data

            this.$emit("input", val)
        },

        removed() {
            this.editModal = false;

            let val = {}
            val[this.field.relation.key[0]] = null
            val[this.field.relation.key[0] + "_RefObj"] = null

            this.$emit("input", val)
        }
    },

    computed: {
        modelUuid() {
            let refObjKey = this.field.relation.key[0] + "_RefObj";

            if (this.value[refObjKey] !== null && this.value[refObjKey] !== undefined) {
                return this.value[refObjKey].uuid
            }

            return null
        }
    },

    mounted() {
         this.$store.dispatch("fetchComponentsSettings", this.field.relation.foreign).then(data => {
            this.component = data
        }).catch(err => {
            this.$bvModal.msgBoxOk("Unexpected error happend.")
        })
    }
}
</script>